/**
 * The app's own waits, page sizes and storage keys. Nothing here is a fact about a backend or a
 * chain. `timing` is a plain object so a test can shorten a wait and put it back.
 */
export const timing = {
  markets: { pollMs: 15_000 },
  /** Long enough that typing "1000" is one request, short enough to feel like an answer. */
  quoteDebounceMs: 450,
  /** The submitted order's watch: fast polls for its first minute, slow ones after, then the Orders page. */
  outcome: { fastPollMs: 4_000, slowPollMs: 10_000, slowAfterMs: 60_000, windowMs: 180_000 },
  /** The clock behind countdowns and elapsed times. */
  tickMs: 1_000,
  healthPollMs: 10_000,
  historyPollMs: 10_000,
  ordersPollMs: 10_000,
  receiptPollMs: 2_000,
  receiptTimeoutMs: 180_000,
  /** The email gate's token is refreshed when it has less than this long to live. */
  supabaseRefreshMarginSec: 60,
  wallet: {
    walletConnectUserActionMs: 180_000,
    walletConnectReadMs: 20_000,
    // A hung relay must not hold the boot screen open indefinitely.
    restoreMs: 8_000,
    // sign-client's five-minute proposal TTL plus a margin, so an orphan cannot pair later.
    walletConnectOrphanWatchMs: 5 * 60_000 + 30_000,
  },
};

export const pageSizes = { orders: 100, history: 50 } as const;

/** A key keeps its value forever: renaming one signs people out or forgets their choices. */
export const storageKeys = {
  auth: "aile.auth",
  chain: "aile.chain",
  emailGate: "aile.emailGate",
  theme: "aile.theme",
  walletRdns: "aile.wallet.rdns",
  walletConnectUnclean: "aile.wallet.wcUnclean",
} as const;

export const errorReporting = { flushIntervalMs: 10_000, maxBatchSize: 20, maxQueueSize: 100, maxSendAttempts: 3 };
